'use client';

import { useTranslations } from 'next-intl';
import { Typography } from '@mui/material';
import { color } from '@/theme/tokens';
import ExpandableSection from './ExpandableSection';

export default function NoticeAndDisclaimerSection() {
    const t = useTranslations('ContactsPage');

    return (
        <ExpandableSection title={t('noticeAndDisclaimerTitle')} maxHeight={{ tablet: 600, mobile: 500 }}>
            <Typography variant="paragraph4regular" color={color.gray[80]}>
                {t('noticeAndDisclaimerBody')}
            </Typography>
        </ExpandableSection>
    );
}
